<script lang="ts" setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import type { Ref } from 'vue'
import { MDCRipple } from '@material/ripple'
import { RippleTheme } from '@/types/ButtonLegacy'

const props = defineProps({
	theme: {
		type: Number,
		default: RippleTheme.Light,
	},
	isAppendRelativeToParent: {
		type: Boolean,
		default: true,
	},
})

const ripple = ref<MDCRipple | null>(null)
const refRipple = ref<Ref | null>(null)
const isThemeLight = computed(() => props.theme === RippleTheme.Light)
const isThemeDark = computed(() => props.theme === RippleTheme.Dark)

function triggerActivateRipple() {
	if (ripple.value === null) {
		return
	}

	ripple.value.activate()
}

function triggerDeactivateRipple() {
	if (ripple.value === null) {
		return
	}

	ripple.value.deactivate()
}

onMounted(() => {
	ripple.value = new MDCRipple(refRipple.value)

	if (props.isAppendRelativeToParent) {
		refRipple.value.parentElement.style.position = 'relative'
	}

	refRipple.value.parentElement.addEventListener('mousedown', () => {
		triggerActivateRipple()
	})
	refRipple.value.parentElement.addEventListener('mouseup', () => {
		triggerDeactivateRipple()
	})
	refRipple.value.parentElement.addEventListener('mouseleave', () => {
		triggerDeactivateRipple()
	})
})

onBeforeUnmount(() => {
	refRipple.value.parentElement.removeEventListener('mousedown', () => {
		triggerActivateRipple()
	})
	refRipple.value.parentElement.removeEventListener('mouseup', () => {
		triggerDeactivateRipple()
	})
	refRipple.value.parentElement.removeEventListener('mouseleave', () => {
		triggerDeactivateRipple()
	})
})
</script>

<template>
	<div
		class="bs-ripple mdc-ripple-surface"
		:class="{
			'bs-ripple--light': isThemeLight,
			'bs-ripple--dark': isThemeDark,
		}"
		ref="refRipple"
	></div>
</template>
